export default () => {
  return {
    title: 'Change your Account Email',
    label: 'Verification Code',
    button: 'Verify',
  };
};
